import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/build/src/components/aspect-ratio.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Research"] */ "/build/src/components/pages/home/research/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/reusables/analytics-404.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/reusables/hubspot-contact-form.tsx");
;
import(/* webpackMode: "eager" */ "/build/src/components/reusables/link-trackers.tsx");
;
import(/* webpackMode: "eager" */ "/build/src/components/reusables/lottie-icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/reusables/topic-tag.tsx");
;
import(/* webpackMode: "eager" */ "/build/src/components/ui/aspect-ratio.tsx");
;
import(/* webpackMode: "eager" */ "/build/src/styles/form.css");
